import { useState } from 'react';

import { DropdownMenu } from '../../../components/modals/dropdown-menu/DropdownMenu';
import { Tooltip } from '../../../components/tooltip/Tooltip';
import { Dot } from './step-status-selector';
import { TaskPropertyButton } from '../../tasks/components/task-property.button';

import styles from './status-selector.module.scss';
type StatusSelectorProps<T extends string> = {
  onChange?: (newStatus: T) => void;
  status: T;
  statusMap: Record<T, { title: string }>;
  isViewOnly?: boolean;
  disableTooltip?: boolean;
  withTitle?: boolean;
  trigger?: React.ReactElement;
};

export const StatusSelector = <T extends string>({
  onChange,
  status,
  statusMap,
  isViewOnly,
  disableTooltip,
  withTitle = false,
  trigger,
}: StatusSelectorProps<T>) => {
  const [isOpen, setIsOpen] = useState(false);

  const onOpenChanged = (value: boolean) => {
    setIsOpen(value);
  };

  if (isViewOnly) {
    return (
      <Tooltip text={statusMap[status]?.title} disabled={disableTooltip}>
        {withTitle ? (
          <TaskPropertyButton
            label={statusMap[status].title}
            icon={<Dot data-status={status} />}
            isDisabled
          />
        ) : (
          <button
            className={`${styles['next']} status-indicator`}
            data-status={status}
            data-is-open={isOpen}
            disabled
          >
            <Dot data-status={status} />
          </button>
        )}
      </Tooltip>
    );
  }

  return (
    <DropdownMenu
      modal
      onOpenChange={onOpenChanged}
      items={Object.entries(statusMap).map(([key, value]) => {
        const { title } = value as { title: string };

        return {
          title,
          onSelect: () => onChange?.(key as T),
          icon: <Dot data-status={key as T} />,
        };
      })}
      align="start"
      className="-ml-4"
      trigger={
        trigger ? (
          <span>{trigger}</span>
        ) : withTitle ? (
          <div>
            <TaskPropertyButton
              label={statusMap[status].title}
              icon={<Dot data-status={status} />}
              isActive
              isDisabled
            />
          </div>
        ) : (
          <button
            className={`${styles['next']} status-indicator`}
            data-status={status}
            data-is-open={isOpen}
          >
            <Dot data-status={status} />
          </button>
        )
      }
    />
  );
};
